import _, { before } from 'lodash';
import Grid from '@mui/material/Grid';
import * as React from 'react';
import { Box } from '@mui/system';
import {makeStyles} from '@material-ui/core/styles';

const pathToParentMenu = ['root'];

const BookImage = (props) => {
    console.log("props",props.totalPageObjs);
    console.log("props111",props.totalPageObjs == 1);
    return (
        <div className='img-shadow'>
        <img src={`${sessionStorage.getItem('media_url')}image/${props.data.image}`} style={props.totalPageObjs == 1 ? {'width':'100%', 'height': '65.6vh'} : {'width':'100%'}}/>
        </div>
    )
}

export default BookImage;